import { render, staticRenderFns } from "./VerticalNavMenuNotification.vue?vue&type=template&id=b7d300fc"
import script from "./VerticalNavMenuNotification.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuNotification.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuNotification.vue?vue&type=style&index=0&id=b7d300fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports